import { DateRanges } from '@app-lib/models/-index';
import { addDays, addMinutes, format, startOfDay } from 'date-fns';

// dalla data o stringa ritorna una stringa iso compatibile con il salvataggio db e il controllo html type="datetime-local"
export function fnToIsoLocalZone(dt: any = null): string {
  let d: Date;
  if (dt == null) {
    d = new Date();
  } else {
    d = new Date(dt.valueOf());
  }
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
}
export function fnToIsoLocalZoneMidnight(dt: any = null): string {
  let d: Date;
  if (dt == null) {
    d = new Date();
  } else {
    d = new Date(dt.valueOf());
  }
  return format(d.setUTCHours(0, 0, 0, 0), 'yyyy-MM-dd 00:00:00');
}

export function fnToIsoLocalZoneAddSeconds(dt: any, s: number): string {
  const cd = new Date(dt.valueOf());
  const d = new Date(cd.setSeconds(cd.getSeconds() + s));
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
}
export function fnToIsoLocalZoneAddDays(dt: any = null, days: number = 1): string {
  let d: Date;
  if (dt == null) {
    d = new Date();
  } else {
    d = new Date(dt.valueOf());
  }
  const da = new Date(addDays(d, days));
  return new Date(da.getTime() - da.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
}

export function fnToIsoLocalZoneAddMinutes(dt: any = null, minutes: number = 1): string {
  let d: Date;
  if (dt == null) {
    d = new Date();
  } else {
    d = new Date(dt.valueOf());
  }
  const da = new Date(addMinutes(d, minutes));
  return new Date(da.getTime() - da.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
}

export function fnToIsoLocalZone_SetHours(dt: any, h: number, m: number, s: number, c: number): string {
  let d: Date;
  if (dt == null) {
    d = new Date();
  } else {
    d = new Date(dt.valueOf());
  }
  d.setHours(h, m, s, c);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
}
export function fnToIsoLocalZoneRoundMinutes(minutes: number, dt: any = null): string {
  var round = 1000 * 60 * minutes;
  var rounded: Date;
  let d: Date;
  if (dt == null) {
    d = new Date();
    rounded = new Date(Math.floor(d.getTime() / round) * round);
  } else {
    d = new Date(dt.valueOf());
    rounded = new Date(Math.floor(d.getTime() / round) * round);
  }
  return new Date(rounded.getTime() - rounded.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
}

export function fnDateDiffMinutes(date1, date2) {
  const d1: Date = new Date(date1);
  d1.setSeconds(0);
  const d2: Date = new Date(date2);
  d2.setSeconds(0);

  return Math.round((d2.getTime() - d1.getTime()) / 60000); // Can use Math.floor or Math.ceil depends up to you
}

// date range picker/
export function fnDateRangeFormat(dt: DateRanges): DateRanges {
  if (dt) {
    dt.from = format(new Date(dt.from), 'yyyy-MM-dd 00:00:00');
    dt.to = format(new Date(dt.to), 'yyyy-MM-dd 23:59:59');
  } else {
    const dn = new Date();
    dt = {
      from: format(dn, 'yyyy-MM-dd 00:00:00'),
      to: format(dn, 'yyyy-MM-dd 23:59:59'),
    };
  }
  return dt;
}
export function fnDateRangeFormatDates(from: any, to: any): DateRanges {
  let ret: DateRanges;
  if (from && to) {
    ret = {
      from: format(from, 'yyyy-MM-dd 00:00:00'),
      to: format(to, 'yyyy-MM-dd 23:59:59'),
    };
  } else {
    const dn = new Date();
    ret = {
      from: format(dn, 'yyyy-MM-dd 00:00:00'),
      to: format(dn, 'yyyy-MM-dd 23:59:59'),
    };
  }
  return ret;
}
